import { render, staticRenderFns } from "./PlayingTV.vue?vue&type=template&id=58c98080"
import script from "./PlayingTV.vue?vue&type=script&lang=js"
export * from "./PlayingTV.vue?vue&type=script&lang=js"
import style0 from "./PlayingTV.vue?vue&type=style&index=0&id=58c98080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports